import SubmitPaymentOption from './SubmitPaymentOption.component';

export default SubmitPaymentOption;
